module.exports = __webpack_public_path__ + "img/i-zcy-bg1.afb8de53.png";